export const PngDescriptions: Record<string, string> = {
  IHDR: "Image Header. Contains key information: width, height, bit depth, color type.",
  PLTE: "Palette. Contains the color palette for indexed color images.",
  IDAT: "Image Data. Contains the actual compressed image data (deflated). Multiple IDAT chunks can exist.",
  IEND: "Image End. Marks the end of the PNG file.",

  // Ancillary chunks
  trns: "Transparency. Specifies transparency information processing.",
  gAMA: "Gamma. Specifies the gamma value of the image source.",
  cHRM: "Primary Chromaticities. Specifies the CIE (x,y) chromaticities.",
  sRGB: "Standard RGB Color Space. Indicates that the image uses the sRGB color space.",
  iCCP: "ICC Profile. Embedded ICC color profile.",
  tEXt: "Textual Data. Contains textual information (Latin-1).",
  zTXt: "Compressed Textual Data. Contains compressed textual information.",
  iTXt: "International Textual Data. Contains textual information (UTF-8).",
  bKGD: "Background Color. Specifies a suggested background color.",
  pHYs: "Physical Pixel Dimensions. Specifies the intended pixel size or aspect ratio.",
  sBIT: "Significant Bits. Indicates the color accuracy of the source data.",
  tIME: "Time. Stores the time the image was last changed.",
  eXIf: "Exif Metadata. Exchangeable image file format data."
};

export const getPngDescription = (name: string): string => {
  return PngDescriptions[name] || "PNG Chunk.";
};
